import React, { useEffect, useState } from "react";
import DashboardLayout from "../../DashboardLayout";
import apiClient from "../../../utils/apiClient";
import { Button } from "../../../components/ui/button";
import { Check, ChevronsUpDown, Edit2Icon, Trash2Icon } from "lucide-react";
import { DeleteUnderlyingModal } from "./DeleteUnderlyingModal";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "../../../components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../components/ui/popover";
import { Label } from "../../../components/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";

import { cn } from "../../../lib/utils";
import { EditCallPutModal } from "./EditCallPutModal";
import server from "../../../utils/serverConfig";

export default function AdditionalStockUnderlyings() {
  const callPutOptionsList = [
    { value: 1, title: "1" },
    { value: 0, title: "0" },
  ];

  const tableHeaders = ["Symbol", "CE", "PUT", "Action"];

  const [stockSymbolsList, setStockSymbolsList] = useState([]);

  const [vmaData, setVmaData] = useState([]);
  const [open, setOpen] = React.useState(false);

  const [stockSymbol, setStockSymbol] = useState("");
  const [callValue, setCallValue] = useState(0);
  const [putValue, setPutValue] = useState(0);
  const [additionUnderlyingStocks, setAdditionUnderlyingStocks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchStocksUnderlyingList();
    fetchAdditionUnderlyingStocks();
  }, []);

  // fetching data from csv sheet to display in select input options
  const fetchStocksUnderlyingList = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}get-stocks-list-options`,
    };

    apiClient
      .request(config)
      .then((response) => {
        const newData = response.data.symbols.map((stock) => {
          return {
            label: stock,
            value: stock,
          };
        });
        console.log("Response is ---->", newData);
        setStockSymbolsList(newData);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // fetching data frpm db to display in table
  const fetchAdditionUnderlyingStocks = () => {
    setIsLoading(true);
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}get-underlying-stocks-list`,
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response table is ---->", response.data.data);
        setAdditionUnderlyingStocks(response.data.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleRemoveSymbolFromList = (symbol) => {
    console.log("Removed Symbol  from List", symbol);

    let config = {
      method: "POST",
      url: `${server.godseye.baseUrl}delete-stock-symbol`,
      data: {
        stockSymbol: symbol,
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response is ---->", response);
        fetchAdditionUnderlyingStocks();
      })
      .catch((error) => {
        console.log(error);
        fetchAdditionUnderlyingStocks();
      });
  };

  const handleAddSymbolToList = () => {
    console.log("Symbol to be added  to List", stockSymbol);

    console.log("Call value", callValue);
    console.log("Removed Symbol  from List", putValue);

    let config = {
      method: "POST",
      url: `${server.godseye.baseUrl}add-stock-symbol`,
      data: {
        stockSymbol: stockSymbol,
        callValue: callValue,
        putValue: putValue,
      },
    };

    if(!stockSymbol){
      return alert("Please select a stock symbol")
    }

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response is ---->", response);
        fetchAdditionUnderlyingStocks();
        setStockSymbol("");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleUpdateCallPutValue = (symbol, newCallValue, newPutValue) => {
    console.log("New CALL value", callValue);
    console.log("New PUT value", putValue);

    let config = {
      method: "POST",
      url: `${server.godseye.baseUrl}update-call-put`,
      data: {
        stockSymbol: symbol,
        callValue: newCallValue,
        putValue: newPutValue,
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response is ---->", response);
        fetchAdditionUnderlyingStocks();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (

      <div className="flex flex-col relative  w-full h-full px-6 font-urbanist">
        <div className="flex items-center justify-between space-x-4 ">
          <div className="flex justify-between items-center  h-[60px]  w-full">
            <p className="flex items-center text-lg font-semibold text-white">
              Additional Stock Underlyings Table
            </p>
          </div>
        </div>

        <div className="flex items-center  space-x-10 h-[60px] w-full">
          <div className="grid grid-cols-1 items-center gap-4">
            <Popover open={open} onOpenChange={setOpen}>
              <PopoverTrigger asChild>
                <Button
                  variant="outline"
                  role="combobox"
                  aria-expanded={open}
                  className="w-[250px] justify-between text-white text-[15px]"
                >
                  {stockSymbol
                    ? stockSymbolsList.find(
                        (stock) => stock.value === stockSymbol
                      )?.label
                    : "Select Stock Symbol"}
                  <ChevronsUpDown className="opacity-80 h-4 w-4" />
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-[250px] p-0 border-zinc-800">
                <Command>
                  <CommandInput
                    placeholder="Search framework..."
                    className="font-poppins"
                  />
                  <CommandList>
                    <CommandEmpty>No framework found.</CommandEmpty>
                    <CommandGroup>
                      {stockSymbolsList.map((stock) => (
                        <CommandItem
                          key={stock.value}
                          value={stock.value}
                          className="font-poppins"
                          onSelect={(currentValue) => {
                            setStockSymbol(
                              currentValue === stockSymbol ? "" : currentValue
                            );
                            setOpen(false);
                          }}
                        >
                          {stock.label}
                          <Check
                            className={cn(
                              "ml-auto h-5 w-5",
                              stockSymbol === stock.value
                                ? "opacity-100"
                                : "opacity-0"
                            )}
                          />
                        </CommandItem>
                      ))}
                    </CommandGroup>
                  </CommandList>
                </Command>
              </PopoverContent>
            </Popover>
          </div>

          <div className="flex items-center w-[250px] space-x-4">
            <Label className=" text-white">CE</Label>
            <Select onValueChange={(value) => setCallValue(value)}>
              <SelectTrigger className=" text-white text-[15px] hover:bg-zinc-800">
                <SelectValue placeholder="Is Call Active" className="" />
              </SelectTrigger>
              <SelectContent className="border-zinc-700">
                <SelectGroup>
                  {callPutOptionsList.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.title}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          <div className="flex items-center w-[250px] space-x-4">
            <Label className=" text-white">PUT</Label>
            <Select onValueChange={(value) => setPutValue(value)}>
              <SelectTrigger className=" text-white text-[15px] hover:bg-zinc-800">
                <SelectValue placeholder="Is Put Active" className="" />
              </SelectTrigger>
              <SelectContent className="border-zinc-700">
                <SelectGroup>
                  {callPutOptionsList.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.title}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Button
              className="bg-zinc-800 text-white text-[15px] hover:bg-zinc-700"
              onClick={() =>
                handleAddSymbolToList(stockSymbol, callValue, putValue)
              }
            >
              Add Symbol to Table
            </Button>
          </div>
        </div>

        <div className="flex flex-col  border border-gray-800   max-h-[calc(100vh-210px)] w-full custom-scroll overflow-hidden overflow-y-auto">
          {isLoading ? (
            <div className="flex items-center justify-center text-[20px] text-white font-medium w-full h-[calc(100vh-210px)]">
              loading....
            </div>
          ) : !isLoading && additionUnderlyingStocks.length === 0 ? (
            <div className="flex items-center justify-center text-[20px] text-white font-medium w-full h-[calc(100vh-210px)]">
              No Data Found
            </div>
          ) : (
            <table className="bg-black text-sm w-full relative z-0">
              <thead className="sticky top-0 bg-[#0F0F0F] text-sm text-left">
                <tr className="text-white border-b border-gray-800">
                  {tableHeaders.map((header, index) => (
                    <th
                      key={index}
                      className={`border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold
                      ${header === "Action" ? "text-center" : "text-left"}  
                    `}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {additionUnderlyingStocks &&
                  additionUnderlyingStocks.map((row, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className="bg-black z-0 border-b last-of-type:border-b-0  border-gray-900 font-medium text-white hover:bg-black/90"
                    >
                      <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900">
                        {row.symbol}
                      </td>
                      <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900">
                        {row.call}
                      </td>
                      <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900">
                        {row.put}
                      </td>
                      <td className="text-center px-2 py-2 border-r last-of-type:border-r-0 border-gray-900">
                        <div className="flex items-center space-x-4 justify-center">
                          <EditCallPutModal
                            symbol={row.symbol}
                            call={row.call}
                            put={row.put}
                            setCallValue={setCallValue}
                            setPutValue={setPutValue}
                            handleUpdateCallPutValue={handleUpdateCallPutValue}
                          />
                          <DeleteUnderlyingModal
                            symbol={row.symbol}
                            handleRemoveSymbolFromList={
                              handleRemoveSymbolFromList
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
        
      </div>

  );
}
